<template>
  <authorization permissionKey="attendance_medical_certificate" can="read">
    <v-container fluid>
      <v-row>
        <v-col class="text-h3 gray--text">
          Atestados
        </v-col>
      </v-row>

      <MedicalCertificateList :attendance="attendance" />
    </v-container>
  </authorization>
</template>

<script>
  import MedicalCertificateList from "@/components/medical_certificates/list/index.vue";

  export default {
    name: "MedicalCertificates",
    props: {
      attendance: Object,
      attendanceEsigned: Boolean,
    },
    components: {
      MedicalCertificateList,
    },
  };
</script>

<style lang="scss" scoped>
  .text {
    white-space: pre-line;
  }
</style>
